<template lang="html">
  <div class="placed-backg" id="about-us-page">

    <section class="main-section">
      <div class="placed-backg box-image"></div>

      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-5 col-xl-6 col-image"></div>

          <div class="col-lg-6 col-text">
            <h1 class="mb-2 title">ESLOWINDOWS</h1>

            <!-- <h5 class="subtitle"></h5> -->
            <p>
              At Eslowindows, we specialize in the design, manufacturing, and installation of high-quality PVC doors and windows. With a commitment to innovation, durability, and energy efficiency, we provide customized solutions that enhance comfort, security, and aesthetics for residential and commercial spaces.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section">
      <div class="container oversized-container">
        <div class="box-plans">
          <h2 class="mb-1 text-center title-2">About Us</h2>

          <!-- <p class="p-md text-center">
            Nuestro plan mundial de cultivo de cáñamo ahora está activo y produce miles de kilogramos de aceite de CBD al por mayor fresco durante todo el año.
          </p> -->

          <div class="row row-plans">
            <div class="col-lg-6 col-plan">
              <h6 class="title">MISSION</h6>
              <p>
                Our mission is to deliver exceptional PVC doors and windows, combining cutting-edge technology, sustainable materials, and superior craftsmanship. We strive to exceed our customers’ expectations by offering durable, energy-efficient, and aesthetically pleasing solutions that improve the quality of life.
              </p>
            </div>

            <div class="col-lg-6 col-plan">
              <h6 class="title">VISION</h6>
              <p>
                To be a leading company in the PVC doors and windows industry, recognized for our excellence in design, quality, and customer satisfaction. We aim to set the standard for innovation and sustainability, providing solutions that contribute to more efficient and environmentally friendly spaces.
              </p>

              <p class="mt-1">
                <router-link class="t-150" to="/contacto"><i class="fa-solid fa-envelope"></i> <u>Send us a message</u></router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {

  data() {
    return {
      aboutus: [
        { bgUrl: 'public/images/pages/about-us/IMG_4895.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4899.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4913.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4935.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4941.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4917.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4933.JPG'},
      ],


      aboutOptions: {
        loop:true,
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
      },

      history:{

      }
    };
  },
  methods: {
      gethistories: function(){
        axios.get(tools.url('/empresaFront')).then(
          ({data}) =>{
            this.history=data;
          });
      }
  },
  mounted() {
      // this.gethistories();
  }
}
</script>
<style>
  @media screen and (max-width: 768px) {
    .slide-text h1 {
        font-size: 3em !important;
    }
    #project-description-section .swiper-container {
        height: 500px !important;
    }
    .center-vertical-obj {
        padding: 1.5em 0 !important;
    }
}
</style>
